import React from 'react'
import '../assets/css/NewHero.css'

export default function NewHero () {
  return (
    <div className='NewHero'>
        <div className="NewHero-Container">
            <div className="NewHero-Square">
                <svg><rect></rect></svg>
               <h1>Nahuel Orselli</h1>
               <h5><span>Front-end Developer</span></h5>
            </div>
        </div>
    </div>
  )
}
